// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { M2M } from '@models/m2m.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class M2MService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getM2Ms(names?: string[]): Observable<M2M[]> {
    let params: HttpParams = new HttpParams();
    if (names) {
      let formattedNames: string = '';
      for (let i = 0; i < names.length; i++) {
        if (i === 0) {
          formattedNames = `${names[i]}`;
        } else {
          formattedNames = `${formattedNames}|${names[i]}`;
        }
      }
      params = params.set('nombres', formattedNames);
    }

    return this.http.get<M2M[]>(`${this.globalService.apiUrl.url}/M2M`, { ...this.httpOptions, params });
  }

  postCreateM2M(m2m: M2M): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/M2M`, m2m, this.httpOptions);
  }

  getM2M(name: string): Observable<M2M> {
    return this.http.get<M2M>(`${this.globalService.apiUrl.url}/M2M/${name}`, this.httpOptions);
  }

  putEditM2M(name: string, m2m: M2M): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/M2M/${name}`, m2m, this.httpOptions);
  }

  deleteM2M(name: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/M2M/${name}`, this.httpOptions);
  }

  postRotateM2MPassword(name: string, newPassword: string): Observable<M2M> {
    let params: HttpParams = new HttpParams();
    params = params.set('newPassword', newPassword);

    return this.http.post<M2M>(`${this.globalService.apiUrl.url}/M2M/${name}/RotatePassword`, null, { ...this.httpOptions, params });
  }

  postRevokeM2MOldPassword(name: string): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/M2M/${name}/RevokeOldPassword`, null, this.httpOptions);
  }
}